import { useEffect, useRef, useState } from "react";
import IconRoundButton from "../../CommonButtons/IconRoundButton";
import PrimaryButton from "../../CommonButtons/PrimaryButton";
import FilteredSearchField from "../../CommonSearchComponents/FilteredSearchField";
import PrimaryWithIconButton from "../../CommonButtons/PrimaryWithIconButton";
import CommonSingleandMultiView from "../../CommonSingleandMultiView";
import formatTotalBalance from "../../../../utils/formatTotalBalance";
import SecondaryAnimatedButton from "../../CommonButtons/SecondaryAnimated";
import SVGComponent from "../../SVGComponent";
import FormatAmount from "../../FormatAmount/FormatAmount";
import {
  IntervalConfiguration,
  ScreenSizeConfiguration,
} from "../../../../utils/configurationProvider";
import SecondaryRightIconSmallButton from "../../CommonButtons/SecondaryRightIconSmallButton";
import CommonDownloadFileWithDropdown from "../../CommonDownloadFileWithDropdown";
import ICONS from "../../../../assets/Icons";
import SwitcherTabs from "../../CommonButtons/SwitcherTabs";
import CountdownTimer from "../../../../utils/countDownCountdownTimer";
/**

@typedef {Object} ButtonProps

@property {string} btnText - The label text displayed on the button

@property {string} btnType - HTML button type (e.g., "button", "submit")

@property {string} enabledBgColor - Background color (CSS variable or hex) when active

@property {string} enabledTextColor - Text color (CSS variable or hex) when active

@property {Function} handleFunction - Callback function triggered on click

@property {boolean} isDisabled - Disables interaction and applies disabled styling

@property {string?} icon - URL or path to the icon image/SVG

@property {("left" | "right")?} iconToBeAlign - Position of the icon relative to text */

/**
@typedef {("primary" | "secondary")} BottomSubTextVaraint
@param {Object} props



@param {ButtonProps} props.topNavCtaBtn1Props - Configuration for the leftmost primary action button.

@param {ButtonProps} props.topNavCtaBtn2Props - Configuration for the secondary primary action button on the right.

@param {Object} props.filteredSearchProps - Configuration for the FilteredSearchField (See FilteredSearchField docs for details).

@param {string} props.BottomHeader - Header text for the secondary info row below the main nav.

@param {BottomSubTextVaraint} props.BottomSubTextVaraint - Sub-header text color for the secondary info row.

@param {Object} props.iconRoundProps - Props for the specialized icon Round button.
@param {Object} props.downloadFileProps - Props for the specialized download file button.
@param {ButtonProps} props.unmatchBtnProps - Props for the specialized unmatch remitter button.
@param {ButtonProps} props.matchBtnProps - Props for the specialized match remitter button.

@param {Object} props.matchRemitterProps - Props for the specialized "Match remitter" animated button.
@param {Boolean} props.openFilter - Props to intially open the filter
@param {Object} props.matchRemitterProps - Props for the specialized "Match remitter" animated button.

@param {boolean} props.isSelectionView - Master toggle to show the selection footer bar (used for bulk actions).

@param {string} props.selectionText - Text displayed during selection mode (e.g., "5 Accounts Selected").

@param {ButtonProps} props.selectionBtnProps - The primary action button to show when items are selected.

@param {bool} props.isFormattingNotRequired - If true then topnavheader will not be formatted as amount

@param {Object} props.direction - direction of scroll to animate top nav.

@returns {JSX.Element} */
const StatementTopNavComponent = ({
  openFilter = false,
  setOpenFilter,
  filteredSearchProps,
  BottomHeader,
  BottomSubTextVaraint,
  isSelectionView,
  selectionText,
  selectionBtnProps,
  topNavCtaBtn1Props,
  topNavCtaBtn2Props,
  ispagination,
  customBottomPadding,
  isFormattingNotRequired,
  iconRoundProps,
  matchRemitterProps,
  downloadFileProps,
  unmatchBtnProps,
  matchBtnProps,
  direction,
  typeToggleState,
  typeToggleSetter,
  isTypeToggleDisabled,
  countDownTimer = false,
  countDownTimerDisabled,
  resetCountDownTimer,
}) => {
  const [search, setSearch] = useState(openFilter);
  const [mobileSearch, setMobileSearch] = useState(false);

  const [isFilterOpen, setIsFilterOpen] = useState(openFilter);
  const [isSortOpen, setIsSortOpen] = useState(false);
  const [isColumnOpen, setIsColumnOpen] = useState(false);
  const containerRef = useRef(null);
  const [isMobile, setIsMobile] = useState(
    window.innerWidth <= ScreenSizeConfiguration.mobileScreen,
  );
  const mobileContainerRef = useRef(null);
  const topNavRef = useRef(null);

  const { isSearchDisabled = false } = filteredSearchProps || {};

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= ScreenSizeConfiguration.mobileScreen);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      const ref = isMobile ? mobileContainerRef : containerRef;

      if (!ref.current) return;
      if (ref.current.contains(e.target)) return;

      topNavRef?.current?.blur();

      setSearch(false);
      setMobileSearch(false);
      setIsFilterOpen(false);
      setIsSortOpen(false);
      setIsColumnOpen(false);
      setOpenFilter?.(false);
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isMobile]);

  useEffect(() => {
    setOpenFilter?.(false);
    setSearch(false);
    setMobileSearch(false);
    setIsFilterOpen(false);
    setIsSortOpen(false);
    setIsColumnOpen(false);
  }, [isMobile]);

  return (
    <>
      {/* MOBILE VIEW */}
      <div
        style={{
          bottom: ispagination
            ? "var(--pagination-height)"
            : customBottomPadding
              ? `var(--${customBottomPadding})`
              : "var(--height-base)",
        }}
        className={`fixed bg-primary-nav shadow-box-shadow-top p-padding-md rounded-t-border-radius-md w-full flex-col max-w-max-content-width item-center h-auto Qsmd:hidden z-z-index-fixed-ui  gap-x-gap-sm gap-y-top_md justify-between ${topNavCtaBtn1Props || topNavCtaBtn2Props ? "flex" : "hidden"}`}
      >
        {mobileSearch && (
          <div class="absolute top-top-base left-left-base bg-PopUp-BackDrop opacity-dark-opacity pointer-events-none w-full h-full z-z-index-content Qsmd:z-z-index-header"></div>
        )}
        <div
          className={`w-full gap-x-gap-sm ${topNavCtaBtn1Props || topNavCtaBtn2Props ? "flex " : "hidden"}`}
        >
          {topNavCtaBtn1Props ? (
            <PrimaryButton
              {...topNavCtaBtn1Props}
              fullWidthRequired={true}
            />
          ) : null}
          {topNavCtaBtn2Props ? (
            <PrimaryButton
              {...topNavCtaBtn2Props}
              fullWidthRequired={true}
            />
          ) : null}
        </div>
      </div>
      <div
        className={`bg-primary-nav w-full flex flex-col overflow-visible Qsmd:px-padding-sm px-padding-md shadow-box-shadow-bottom ${direction === "down" ? "absolute topnavanime" : direction === "up" ? "absolute topnavanimeup" : ""}`}
      >
        <div className="bg-primary-nav w-full flex flex-col max-w-max-content-width mx-auto relative">
          {/* WEBVIEW */}
          <div
            style={{ overflowX: "clip" }}
            className="w-full hidden Qsmd:flex flex-wrap max-w-max-content-width item-center min-h-topnavbar-min-height h-auto relative topnav-webview gap-gap-sm py-padding-sm justify-between"
          >
            <div
              className={`${topNavCtaBtn1Props ? "flex" : "hidden"} ${search ? "opacity-opacity-none" : ""} transition-all duration-animation-fast-s ease-in-out gap-x-gap-sm items-center overflow-hidden`}
            >
              <PrimaryButton {...topNavCtaBtn1Props} />
            </div>
            <div
              className={`${filteredSearchProps ? "flex" : "hidden"} flex-1 ${search ? "" : "relative"} min-h-topnavheight  min-w-search-min-width`}
            >
              <div
                ref={containerRef}
                onClick={(e) => {
                  if (isSearchDisabled) return;
                  if (isFilterOpen || isSortOpen || isColumnOpen) {
                  } else {
                    setSearch((prev) => !prev);
                  }
                }}
                className={`absolute inset-top-base flex items-center justify-center transition-all duration-animation-fast-s ease-in-out ${search ? "scale-full-scale opacity-base-opacity z-z-index-overlay" : `${topNavCtaBtn1Props || matchRemitterProps || iconRoundProps || topNavCtaBtn2Props ? "Qsmd:scale-x-full-scale-animate Qsmd:scale-y-full-scale scale-full-scale" : "scale-full-scale"}   z-z-index-header`}`}
              >
                {filteredSearchProps && !isMobile && (
                  <FilteredSearchField
                    setOpenFilter={setOpenFilter}
                    openFilter={openFilter}
                    {...filteredSearchProps}
                    isTopNavSearch={search}
                    isTopNav={true}
                    setTopNavSearch={(val) =>
                      setSearch((prev) => (prev === null ? true : val))
                    }
                    setIsFilterOpen={setIsFilterOpen}
                    setIsSortOpen={setIsSortOpen}
                    setIsColumnOpen={setIsColumnOpen}
                    topNavRef={topNavRef}
                  />
                )}
              </div>
            </div>

            <div
              className={`${iconRoundProps || matchRemitterProps || topNavCtaBtn2Props || downloadFileProps ? "flex" : "hidden"} ${search ? "opacity-opacity-none" : ""} transition-all duration-animation-fast-s ease-in-out gap-x-gap-sm items-center`}
            >
              {matchRemitterProps ? (
                <SecondaryAnimatedButton
                  {...matchRemitterProps}
                  icon={ICONS.MATCH}
                  text="Match remitter"
                />
              ) : null}

              {iconRoundProps ? <IconRoundButton {...iconRoundProps} /> : null}

              {downloadFileProps ? (
                <CommonDownloadFileWithDropdown
                  btnText="Download statement"
                  dropdownOptions={["XLSX", "CSV", "TSV", "PDF"]}
                  icon={ICONS?.DOWNLOAD_STATEMENT}
                  {...downloadFileProps}
                />
              ) : null}
              {topNavCtaBtn2Props ? (
                <PrimaryButton {...topNavCtaBtn2Props} />
              ) : null}
            </div>
          </div>

          {/* MOBILE VIEW */}
          <div
            style={{ overflowX: "clip" }}
            className="w-full flex flex-col max-w-max-content-width item-center h-auto relative Qsmd:hidden justify-between"
          >
            <div
              className={`${filteredSearchProps ? "flex" : "hidden"} flex-1 relative min-h-topnavbar-min-height ${filteredSearchProps ? "pb-padding-sm" : "py-padding-sm"}`}
            >
              <div
                ref={mobileContainerRef}
                onClick={(e) => {
                  if (isSearchDisabled) return;
                  if (isFilterOpen || isSortOpen || isColumnOpen) {
                  } else {
                    setMobileSearch(true);
                  }
                }}
                className={`absolute inset-top-base flex items-center justify-center transition-all duration-animation-fast-s ease-in-out z-z-index-header ${search ? "scale-full-scale opacity-base-opacity z-z-index-overlay" : "scale-x-full-scale-animate scale-y-full-scale"}`}
              >
                {filteredSearchProps && isMobile && (
                  <FilteredSearchField
                    setOpenFilter={setOpenFilter}
                    openFilter={openFilter}
                    {...filteredSearchProps}
                    isTopNavSearch={mobileSearch}
                    isTopNav={true}
                    setTopNavSearch={(val) =>
                      setMobileSearch((prev) => (prev === null ? true : val))
                    }
                    setIsFilterOpen={setIsFilterOpen}
                    setIsSortOpen={setIsSortOpen}
                    setIsColumnOpen={setIsColumnOpen}
                    topNavRef={topNavRef}
                  />
                )}
              </div>
            </div>
            <div
              className={`${matchRemitterProps || iconRoundProps || downloadFileProps ? "flex" : "hidden"} gap-x-gap-md justify-end} ${filteredSearchProps ? "border-t-border border-primary-bg" : ""}  w-full pb-padding-sm`}
            >
              <div
                className={`${matchRemitterProps || iconRoundProps || downloadFileProps ? "flex pt-top_sm" : "hidden"}  gap-x-gap-sm items-center`}
              >
                {matchRemitterProps ? (
                  <SecondaryAnimatedButton
                    {...matchRemitterProps}
                    icon={ICONS.MATCH}
                    text="Match remitter"
                  />
                ) : null}

                {iconRoundProps ? (
                  <IconRoundButton {...iconRoundProps} />
                ) : null}
                {downloadFileProps ? (
                  <CommonDownloadFileWithDropdown
                    btnText="Download statement"
                    dropdownOptions={["XLSX", "CSV", "TSV", "PDF"]}
                    icon={ICONS?.DOWNLOAD_STATEMENT}
                    {...downloadFileProps}
                  />
                ) : null}
              </div>
            </div>
          </div>
          <div
            className={`flex-col Qsmd:flex-row items-start py-padding-sm gap-y-gap-sm Qsmd:items-center justify-between border-t-border border-primary-bg ${BottomHeader ? "flex" : "hidden"}`}
          >
            <p className="text-text-primary text-font-xs font-normal flex">
              {BottomHeader}
              {countDownTimer ? (
                <>
                  refreshing statement in :&nbsp;
                  <CountdownTimer
                    time={IntervalConfiguration.statementRefreshTime}
                    resetTrigger={resetCountDownTimer}
                    isDisabled={countDownTimerDisabled}
                  />
                </>
              ) : null}
            </p>
            {typeToggleState ? (
              <SwitcherTabs
                initialActiveTab={"Credit"}
                tabs={[
                  {
                    label: "Credit",
                    key: "Credit",
                    handler: () => typeToggleSetter("Credit"),
                    isDisabled: isTypeToggleDisabled,
                  },
                  {
                    label: "Debit",
                    key: "Debit",
                    handler: () => typeToggleSetter("Debit"),
                    isDisabled: isTypeToggleDisabled,
                  },
                ]}
                isDisabled={isTypeToggleDisabled}
                swicherTabBgColor={"var(--primary-card)"}
                state={typeToggleState}
              />
            ) : undefined}
          </div>
          <div
            className={`py-padding-sm Qsmd:items-center flex-col Qsmd:flex-row justify-between border-t-border border-primary-bg ${unmatchBtnProps || matchBtnProps ? "gap-y-gap-sm" : ""}  ${isSelectionView ? "flex" : "hidden"}`}
          >
            <div
              className={`${unmatchBtnProps || matchBtnProps || selectionText ? "flex" : "hidden"} gap-x-gap-sm`}
            >
              {unmatchBtnProps ? (
                <>
                  <SecondaryRightIconSmallButton {...unmatchBtnProps} />
                  <div className="h-auto border-r-border border-primary-bg"></div>
                </>
              ) : null}
              {matchBtnProps ? (
                <>
                  <SecondaryRightIconSmallButton {...matchBtnProps} />
                  <div className="h-auto Qsmd:flex hidden border-r-border border-primary-bg"></div>
                </>
              ) : null}
              <p className="text-text-primary Qsmd:flex hidden text-font-xs font-normal my-auto">
                {selectionText}
              </p>
            </div>
            <div className="flex gap-x-gap-sm justify-between Qsmd:border-none border-primary-bg">
              <p className="text-text-primary Qsmd:hidden flex mr-margin-md text-font-xs font-normal my-auto">
                {selectionText}
              </p>

              {selectionBtnProps ? (
                <SecondaryRightIconSmallButton {...selectionBtnProps} />
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StatementTopNavComponent;
